import React, {useState} from 'react';
import SegmentedButton from './SegmentedButton';
// import Gauge from './Gauge';
import TemperatureSelector from './TemperatureSelector';
import Graph from './Graph';
import './MainTab.css';
import './Label.css'
import TemperatureGauge from './TemperatureGauge';
import TokensContext from '../TokensContext';
import { useContext } from 'react';

const MainTab = () => {
    const [updateKey, setUpdateKey] = useState(0);
    const {heaterOnly, heaters} = useContext(TokensContext);

    const handleTemperatureChange = () => {
        setTimeout(() => { //delayed refresh
            setUpdateKey(prevKey => prevKey + 1); // This will cause a re-render of SegmentedButton
        }, 1000);
    };


return (
    <div className='main-tab-container pt-3'>
        {heaters.map((heater) => (
                <div key={heater.name}>
                    <span className='label button-label'>{heater.name}</span>
                    <SegmentedButton 
                        heaterToken={heater.token}
                    />
                </div>
            ))}
        {!heaterOnly &&
            <div>
                <div className='row mt-3 mb-0 mx-0'>
                    <div className='col'>
                        <span className='label control-label'>Temperatura Actual</span>
                    </div>
                    <div className='col'>
                        <span className='label control-label'>Temperatura Deseada</span>
                    </div>
                </div>
                <div className='row mb-2 mx-0 align-items-center'>
                    <div className='col'>
                        <TemperatureGauge/>
                    </div>
                    <div className='col'>
                        <TemperatureSelector onTemperatureChange={handleTemperatureChange} />
                    </div>
                </div>
            </div>
        }
        <Graph />
    </div>
    );
}

export default MainTab;
